import { allUsersUrl } from "services/url/auth";

import axios from "services/httpInstance/axios";

export const getAllUsers = (data) => {
    return axios.get(allUsersUrl(data));
}